import type { TFunction } from 'i18next';
import Joi from 'joi';

export interface PasswordFormData {
	email: string;
	password: string;
}

export function passwordFormSchema(t: TFunction) {
	return Joi.object<PasswordFormData>({
		email: Joi.string()
			.trim()
			.email({ tlds: { allow: false } })
			.required()
			.messages({
				'string.base': t('password_step.validation.email.required'),
				'string.empty': t('password_step.validation.email.required'),
				'string.email': t('password_step.validation.email.format'),
			}),
		password: Joi.string()
			.required()
			.messages({
				'string.base': t('password_step.validation.password.required'),
				'string.empty': t('password_step.validation.password.required'),
			}),
	});
}
